import { Injectable } from '@angular/core';
import { SearchResultHelper } from 'core/utils/search-result-helper';
import {
  CustomShowcaseEntityDto,
  defaultTopicParams,
  ExtractedMultipleShowcase,
  ExtractedShowcase, ExtractedSingleShowcaseResource,
  ShowcaseHit,
  ShowcasesTypes,
  StoredShowcaseData,
} from 'search/full-card/models/showcases';
import { SearchResult } from 'search/models/search-results';

@Injectable({
  providedIn: 'root',
})
export class ShowcaseHelperService {

  constructor(private srh: SearchResultHelper) {
  }

  public extractShowcaseData(showcaseType: ShowcasesTypes, showcase: StoredShowcaseData, isMultiple: boolean): ExtractedShowcase {
    switch (showcaseType) {
      case ShowcasesTypes.CONTRIBUTORS:
        return showcase;
      case ShowcasesTypes.TOPICS:
        return {
          ...showcase,
          data: [...this.extractMultipleShowcaseData(showcase.data)],
        };
      case ShowcasesTypes.CUSTOM:
        const data = isMultiple
          ? this.extractMultipleShowcaseData(showcase.data)
          : this.extractSingleShowcaseData(showcase.data);
        return {
          ...showcase,
          data: [...data],
        };
      default:
        return {
          ...showcase,
          data: [...this.extractSingleShowcaseData(showcase.data)],
          identifier: showcase.identifier,
        };
    }
  }

  public extractSingleShowcaseData(inputData: any): ExtractedSingleShowcaseResource[] {
    if (!Array.isArray(inputData)) {
      return [];
    }

    return inputData.map((item) => ({
      id: item.id,
      entityType: item.entityType,
      title: this.srh.extractTitle(item) || item.label,
      author: item.primaryAgent,
      isUnresolved: item.isUnresolved,
      date: this.srh.extractPublicationDate(item),
      coverConfig: {
        coverUrl: item.coverUrl,
        type: item.entityType,
      },
    }));
  }

  public extractMultipleShowcaseData(hits: ShowcaseHit[]): ExtractedMultipleShowcase[] {
    if (!hits[0]?.relatedResources) {
      return [];
    }

    return hits.map((hit: any) => {
      const totalResources = hit.relatedResources.totalResults;
      return {
        id: hit.resource?.id || hit.metadata?.id,
        label: hit.resource?.label || hit.metadata?.name,
        identifier: hit.identifier,
        isExtendable: totalResources > defaultTopicParams.maxTopicResourcesNumber,
        description: hit.resource?.description?.[0]?.label || null,
        metadata: hit.metadata,
        totalResources,
        resources: hit.relatedResources.data.map((resource: SearchResult | CustomShowcaseEntityDto) => ({
          id: resource.id,
          entityType: resource.entityType,
          title: this.srh.extractTitle(resource),
          coverConfig: {
            coverUrl: resource.coverUrl,
            type: resource.entityType,
          },
        })).slice(0, defaultTopicParams.maxTopicResourcesNumber),
      };
    });
  }
}
